export default class SingletonService {
    store = null;

    serviceName = null;

    constructor(serviceName) {
        this.serviceName = serviceName;
    }

    getStore() {
        if (!this.store) {
            if (!window.sspStores) {
                window.sspStores = {};
            }
            if (!window.sspStores.services) {
                window.sspStores.services = {};
            }
            this.store = window.sspStores.services;
        }
        return this.store;
    }

    getService() {
        return this.getStore()[this.serviceName];
    }

    setService(instance) {
        this.getStore()[this.serviceName] = instance;
    }

    isInitialized() {
        return !!this.getService();
    }
}
